<div class="row justify-content-center max-375 m-auto">
  <div class="col-11 quiz " [ngClass]="{'correct': correct, 'incorrect': incorrect}">
    <div class="row justify-content-center">
      <!-- <div class="col-3 px-4"> -->
        <div class="quiz-img">
          <img src="../../../../assets/brain.png"/>
    <!-- </div> -->
      </div>
    </div>
    <div class="row justify-content-center position-relative overflow-hidden">
      <div class="col-12 px-4" [class.hide-right]="correct || incorrect">
        <h5 class="text-center">{{ question }}</h5>
      </div>
      <div class="d-flex h-100 w-100 position-absolute answer hide-left" [class.display-x]="correct || incorrect">
        <h4 class="text-center my-auto mx-auto">{{ answer }}</h4>
      </div>
    </div>
    <div class="row justify-content-center radio-button mt-3 answers o-1" [class.o-0]="correct || incorrect">
      <div *ngFor="let answer of answers " class="col-auto px-2 d-flex">
        <input (click)="submitAnswer(answer.answer)" type="radio" [value]="answer.choice" name="drone">
        <label class="ml-1" [for]="answer.choice">{{ answer.choice }}</label>
      </div>
    </div>
    <div class="row justify-content-center w-100 status" [class.display-status]="correct || incorrect">
      <h5 class="text-center">{{ status }}</h5>
    </div>
  </div>
</div>
